var _defs, _rect, _g, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceScene(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 560,
    viewBox: "0 0 360 560",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gs",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0f2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#203a43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2c5364"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 560,
    fill: "url(#gs)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(255,255,255,0.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 40,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 80,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 50,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 100,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 60,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 120,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 200,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 180,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 220,
    r: 1
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 400,
    r: 70,
    fill: "rgba(255,255,255,0.2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceScene);
export default __webpack_public_path__ + "static/media/space-scene.35ce2d84fb30df43d4f6d4bc12a9fda5.svg";
export { ForwardRef as ReactComponent };